<template>
  <div class="tab-component">
    <div ref="tabBoxOuter" style="width: 100%; overflow: scroll; -webkit-overflow-scrolling: touch">
      <tab
        ref="tabBox"
        style="background-color: #f2f4f5; font-size: 14px"
        bar-active-color="#149c81"
        :line-width="4"
        :custom-bar-width="getBarWidth"
        :style="{ width: tabWidth + 'px' }"
      >
        <tab-item v-for="(item, index) in tabList" :key="index" @on-item-click="onItemClick(item, index)">{{ item }} </tab-item>
      </tab>
    </div>
  </div>
</template>

<script>
import { Tab, TabItem } from 'vux/src/components/tab'
export default {
  components: {
    Tab,
    TabItem
  },
  props: {
    tabList: {
      type: Array
    }
  },
  data() {
    return {
      // tab标签div长度
      tabWidth: document.body.clientWidth
    }
  },
  mounted() {
    this.setTabWidth()
    this.clickFirstItem()
  },
  methods: {
    onItemClick(keyword, index) {
      this.$emit('changeTab', index, keyword)
      let barLeft = 0
      document.getElementsByClassName('vux-tab-ink-bar')[0].style.right = '100%'
      for (let i = 0; i < this.tabList.length; ) {
        if (document.getElementsByClassName('vux-tab-item')[i].innerText === keyword) {
          barLeft += document.getElementsByClassName('vux-tab-item')[i].offsetWidth / 2
          barLeft -= 22.5
          break
        }
        barLeft += document.getElementsByClassName('vux-tab-item')[i].offsetWidth
        i += 1
      }
      document.getElementsByClassName('vux-tab-ink-bar')[0].style.left = barLeft + 'px'
    },
    getBarWidth() {
      if (this.tabList && this.tabList.length === 1) {
        return '0px'
      }
      return '45px'
    },
    setTabWidth() {
      // 页面完成刷新之后
      this.$nextTick(() => {
        let ofwidth = 0
        let efwidth = 0
        for (let i = 0; i < this.$refs.tabBox.$children.length; ) {
          efwidth += this.$refs.tabBox.$children[i].$el.offsetWidth
          i += 1
        }
        for (let i = 0; i < this.$refs.tabBox.$children.length; ) {
          ofwidth += this.$refs.tabBox.$children[i].$el.offsetWidth
          if (ofwidth > document.body.clientWidth) {
            break
          }
          i += 1
        }
        if (ofwidth < document.body.clientWidth) {
          for (let i = 0; i < this.$refs.tabBox.$children.length; ) {
            this.$refs.tabBox.$children[i].$el.style.width =
              this.$refs.tabBox.$children[i].$el.clientWidth + (document.body.clientWidth - ofwidth) / this.$refs.tabBox.$children.length + 'px'
            i += 1
          }
          this.tabWidth = document.body.clientWidth
        } else {
          this.tabWidth = efwidth
        }
      }, 1000)
    },
    clickFirstItem() {
      setTimeout(() => {
        this.$refs.tabBox.$children[0].onItemClick()
      }, 200)
    },
    clickTabItemById(index) {
      // 模拟点击事件
      this.$refs.tabBox.$children[index].onItemClick()
      let tabConter = (document.body.clientWidth - this.$refs.tabBox.$children[index].$el.offsetWidth) / 2
      this.$refs.tabBoxOuter.scrollLeft = this.$refs.tabBox.$children[index].$el.offsetLeft - tabConter
    }
  }
}
</script>

<!--此style用来设置组件去除横向滚动条显示-->
<style scoped>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸,在这里设置滚动条宽度为0px*/
::-webkit-scrollbar {
  width: 0px;
  display: none;
  background-color: #fff;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}
</style>
<!--此style用来设置vux组件的部分样式调整-->
